import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-040d42b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhum comentário por aqui", -1))
const _hoisted_3 = { class: "header__content" }
const _hoisted_4 = { class: "header__container" }
const _hoisted_5 = { class: "header__title" }
const _hoisted_6 = { class: "box" }
const _hoisted_7 = { class: "course__about" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "body__title" }, "Treinamentos relacionados ao interesse:", -1))
const _hoisted_9 = { class: "interest__filter" }
const _hoisted_10 = { class: "filter-item-search" }
const _hoisted_11 = { class: "filter-item-select" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Todos", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Em andamento", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Finalizado", -1))
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "cards" }
const _hoisted_17 = {
  key: 0,
  class: "card-wrapper"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "finished-flag"
}
const _hoisted_20 = {
  key: 2,
  class: "progress-flag"
}
const _hoisted_21 = { class: "card__content" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "card__information" }
const _hoisted_24 = {
  key: 0,
  class: "decoins"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-ls-module": "progressBar",
  role: "progressbar",
  "aria-valuenow": "60"
}, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "no-trainings"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Nenhum treinamento encontrado. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalIntroductoryContent = _resolveComponent("ModalIntroductoryContent")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_content_fallback = _resolveComponent("content-fallback")!
  const _component_CommentsModal = _resolveComponent("CommentsModal")!
  const _component_Search = _resolveComponent("Search")!
  const _component_VideoPlayButton = _resolveComponent("VideoPlayButton")!
  const _component_ButtonComment = _resolveComponent("ButtonComment")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.openModalIntroductoryContent && _ctx.course && _ctx.course.introductoryContent)
      ? (_openBlock(), _createBlock(_component_ModalIntroductoryContent, {
          key: 0,
          onClose: _ctx.closeModalIntroductoryContent,
          "introductory-content": _ctx.course.introductoryContent
        }, null, 8, ["onClose", "introductory-content"]))
      : _createCommentVNode("", true),
    (_ctx.isCommentsModalOpen)
      ? (_openBlock(), _createBlock(_component_CommentsModal, {
          key: 1,
          onCloseCommentsModal: _ctx.closeCommentsModal,
          title: _ctx.commentModalTitle
        }, {
          default: _withCtx(() => [
            (_ctx.comments.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.comments, (comment, index) => {
                  return (_openBlock(), _createBlock(_component_Comment, {
                    key: index,
                    "user-name": comment.userName,
                    comment: comment.message,
                    date: _ctx.toLocaleDateTime(comment.createAt),
                    stars: comment.rating,
                    "user-image": comment.userImage,
                    "content-name": comment.contentName
                  }, null, 8, ["user-name", "comment", "date", "stars", "user-image", "content-name"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_content_fallback, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onCloseCommentsModal", "title"]))
      : _createCommentVNode("", true),
    _createElementVNode("header", {
      class: "header",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.interestImageURL})` })
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.interestTitle), 1)
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("section", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_Search, {
              onSearching: _cache[0] || (_cache[0] = ($event: any) => (_ctx.search(_ctx.$router, $event, 'title'))),
              "search-bar-text": "Pesquisar treinamento",
              height: '35px',
              fontSize: '15px',
              id: "search-courses"
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              class: "select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStatus) = $event)),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onStatusChange && _ctx.onStatusChange(...args)))
            }, _hoisted_15, 544), [
              [_vModelSelect, _ctx.selectedStatus]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.trainings.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainings, (training) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card",
                    key: training.id,
                    onClick: ($event: any) => (_ctx.goToTrainingView(training.id))
                  }, [
                    (training.haveCertification)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onMousemove: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                          title: "Certificado",
                          class: "card__certificate"
                        }, null, 32))
                      : _createCommentVNode("", true),
                    (training.statusCourse.finished)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Concluído"))
                      : _createCommentVNode("", true),
                    (training.statusCourse.progress)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Em andamento"))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(['card__img', { finished: training.statusCourse.finished }]),
                      style: _normalizeStyle({ backgroundImage: `url(${training.imageURL})` })
                    }, [
                      (training.hasNewContent)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onMousemove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                            class: "card__new_contents"
                          }, null, 32))
                        : _createCommentVNode("", true),
                      (_ctx.isNewCourse(training))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onMousemove: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                            class: "card__release_course"
                          }, null, 32))
                        : _createCommentVNode("", true),
                      (training.introductoryContent)
                        ? (_openBlock(), _createBlock(_component_VideoPlayButton, {
                            key: 2,
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openIntroductoryContent()), ["stop"])),
                            class: "video-play-button"
                          }))
                        : _createCommentVNode("", true)
                    ], 6),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", {
                        class: "card__title",
                        title: training.title,
                        onMousemove: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                      }, _toDisplayString(training.title), 41, _hoisted_22),
                      _createElementVNode("div", _hoisted_23, [
                        (training.haveDecoins && _ctx.isDecolaTemplate())
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          (training.duration)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onMousemove: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                                class: "card__duration",
                                title: "Duração"
                              }, _toDisplayString(_ctx.formattedDuration(training.duration)), 33))
                            : _createCommentVNode("", true),
                          (Number(training.rating) > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                onMousemove: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                                class: "card__rating",
                                title: "Avaliação"
                              }, _toDisplayString(parseFloat(training.rating.toString()).toFixed(1)), 33))
                            : _createCommentVNode("", true)
                        ]),
                        (training.haveComments)
                          ? (_openBlock(), _createBlock(_component_ButtonComment, {
                              key: 1,
                              class: "card__comments",
                              onClick: _withModifiers(($event: any) => (_ctx.loadCourseCommentsModal(training)), ["stop"])
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_25
                    ])
                  ], 8, _hoisted_18))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createVNode(_component_ContentFallback, null, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 1
                })
              ])),
          (_ctx.numberOfPages > 0)
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 2,
                "qt-pages": _ctx.numberOfPages,
                currentPage: Number(_ctx.$route.query.page) || 1,
                onChangePage: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateQuery(_ctx.$router, 'page', $event)))
              }, null, 8, ["qt-pages", "currentPage"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}